<template>
    <div>
        <p class="info-label">{{ $l10n.__('Etat du compte') }}</p>
        <p class="info-value"><span v-bind:class="['chip', chipColor]"></span>{{ translation }}</p>
    </div>
</template>

<script>
export default {
    props: {
        'status' : {
            type: String,
            required: false
        }
    },
    computed:{
        chipColor: function () {
            const colors = {
                'error'         : 'error',
                'manual'        : 'success',
                'deleted'       : 'error',
                'connected'     : 'success',
                'disconnected'  : 'secondary'
            }
            return 'chip-' + colors[this.status]
        },

        translation: function () {
            const translation = {
                'error'         : this.$l10n.__('Erreur de synchronisation'),
                'manual'        : this.$l10n.__('Manuel'),
                'deleted'       : this.$l10n.__('Supprimé'),
                'connected'     : this.$l10n.__('Synchronisé'),
                'disconnected'  : this.$l10n.__('Désactivé')
            }
            return translation[this.status]
        }
    }
}
</script>
